import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import FileInput from '@/Shared/FileInput';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import LoadingButton from '@/Shared/LoadingButton';
export default {
  components: {
    FileInput: FileInput,
    Head: Head,
    Link: Link,
    LoadingButton: LoadingButton,
    SelectInput: SelectInput,
    TextInput: TextInput
  },
  layout: Layout,
  remember: 'form',
  data: function data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        user_type: 'sbu_head',
        photo: null
      })
    };
  },
  methods: {
    store: function store() {
      this.form.post('/users');
    }
  }
};